/**
 * Side drawer component
 * 
 * @module side-drawer
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'side-drawer';

if (!customElements.get(customElements.component)) {
  
    class quantitySelector extends HTMLElement {

        /**
         * Web component constructor
         * 
         * @constructor
         */
        constructor() {

            super();

            this.style.display = 'none';
            
            this.classList.add('side-drawer');

            this.render();
        }

        /**
         * Render component in the DOM
         * 
         * @returns {undefined}
         */
        render() {

            // Render template

            let html = this.template();

            html = html.replace(/{{content}}/g, this.innerHTML);

            this.innerHTML = html;

            // After render template

            this.initEvents();

            //this.style.display = '';
        }

        /**
         * Component template
         * 
         * @returns {undefined}
         */
         template() {

            if (window.templateSideDrawer) {

                return window.templateSideDrawer;

            } else {

                return `
                    <div data-overlay></div>
                    <div data-container>
                        <button data-close>
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close fill-black"width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M41.9587 14.1554L38.8449 11.0416L26.5003 23.3862L14.1557 11.0416L11.042 14.1554L23.3866 26.5L11.042 38.8445L14.1557 41.9583L26.5003 29.6137L38.8449 41.9583L41.9587 38.8445L29.6141 26.5L41.9587 14.1554Z" stroke="none"/>
                            </svg>
                            Close
                        </button>
                        <div data-content>{{content}}</div>
                    </div>
                `;
            }
        }

        /**
         * Init component events
         * 
         * @returns {undefined}
         */
        initEvents() {

            this.initFocusTrap();

            this.initTriggers();

            // Close on press escape
            window.addEventListener('escape', () => {
                this.close();
            });
        }

        /**
         * Init triggers
         * 
         * @returns {undefined}
         */
        initTriggers() {

            if(this.id) {

                document.querySelectorAll('[data-drawer-target="'+this.id+'"]').forEach( element => {
                    element.addEventListener('click', this.open.bind(this));
                });

            }

            this.querySelector('[data-overlay]').addEventListener('click', this.close.bind(this));

            this.querySelectorAll('[data-close]').forEach( element => { 
                element.addEventListener('click', this.close.bind(this)); 
            });
        }

        /**
         * Check if the drawer is open
         * 
         * @returns {boolean}
         */
        isOpen() {

            return (this.classList.contains('active')) ? true : false;
        }

        /**
         * Open drawer
         * 
         * @returns {undefined}
         */
        open(event) {

            if(event) event.preventDefault();

            if (!this.isOpen()) {

                this.style.display = '';

                setTimeout(() => {
                    this.classList.add('active');
                    this.classList.add('transition-in');
                }, 100);

                setTimeout(() => {
                    this.classList.remove('transition-in');
                    this.activeFocusTrap();
                }, 300);
            }
        }

        /**
         * Close drawer
         * 
         * @returns {undefined}
         */
        close() {

            if (this.isOpen()) {

                this.classList.add('transition-out');
                this.disableFocusTrap();

                setTimeout(() => {
                    this.classList.remove('transition-out');
                    this.classList.remove('active');
                }, 300);

                setTimeout(() => {
                    this.style.display = 'none';
                }, 400);
            }
        }

        /**
         * Init focus trap
         * 
         * @returns {undefined}
         */
        initFocusTrap() {

            this.focusTrap = focusTrap.createFocusTrap(this, { clickOutsideDeactivates: true }); 
        }

        /**
         * Disable focus trap
         * 
         * @returns {undefined}
         */
        disableFocusTrap() {

            if (this.focusTrap) {
                this.focusTrap.deactivate();
            }
        }

        /**
         * Active focus trap
         * 
         * @returns {undefined}
         */
        activeFocusTrap() {

            if (this.focusTrap) {
                this.focusTrap.activate();
            }
        }
    }

    customElements.define(customElements.component, quantitySelector);
}
